import {
  type Notification,
  NotificationSchema,
  type NotificationSubscription,
  NotificationSubscriptionSchema,
} from '../model/schema'

export interface NotificationDto {
  id: string
  employee_id: string
  kind: string
  title: string
  body?: string
  task_id?: string
  idle_proposal_id?: string
  proposed_stopped_at?: string
  created_at: string
  // omitempty на бэке: поле отсутствует у непрочитанного.
  read_at?: string | null
}

// exactOptionalPropertyTypes: omitempty-поля бэка либо отсутствуют, либо есть —
// подмешиваем ключ только когда значение непусто, а не пишем `undefined`.
export function toNotification(dto: NotificationDto): Notification {
  return NotificationSchema.parse({
    id: dto.id,
    employeeId: dto.employee_id,
    kind: dto.kind,
    title: dto.title,
    ...(dto.body ? { body: dto.body } : {}),
    ...(dto.task_id ? { taskId: dto.task_id } : {}),
    ...(dto.idle_proposal_id ? { idleProposalId: dto.idle_proposal_id } : {}),
    ...(dto.proposed_stopped_at ? { proposedStoppedAt: dto.proposed_stopped_at } : {}),
    createdAt: dto.created_at,
    readAt: dto.read_at ?? null,
  })
}

export interface NotificationSubscriptionDto {
  kind: string
  enabled: boolean
}

// Незнакомый вид пропускается, а не роняет разбор: каталог бэка может уехать
// вперёд релиза SPA. Строгий parse здесь стоил бы страницы настроек целиком —
// ровно так `kind` вне каталога однажды положил разбор всей ленты.
export function toNotificationSubscriptions(
  dtos: NotificationSubscriptionDto[],
): NotificationSubscription[] {
  return dtos.flatMap((dto) => {
    const parsed = NotificationSubscriptionSchema.safeParse(dto)
    return parsed.success ? [parsed.data] : []
  })
}
